import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import EditarHistoricoARP from './tiposEntrada/editarHistoricoARP.';
import EditarHistoricoCompraEmergencial from './tiposEntrada/editarHistoricoCompraEmergencial';
import EditarHistoricoDefesaCivil from './tiposEntrada/editarHistoricoDefesaCivil';
import Input from '../../../../components/Input/input.component';
import Required from '../../../../components/Required/required.component';
import EditarEmpresa from './comum/editarEmpresa';
import { EntradaArpValidationSchema, EntradaCompraEmergencialValidationSchema, EntradaDefesaCivilValidationSchema } from '../editarHistoricoDACA.modal.validates';


class EditarHistoricoDACAEntrada extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const { transacao, handleValidationSchema } = this.props;
		switch (transacao.destinoEstoque.tipoEstoque) {
		case 'ARP':
			handleValidationSchema(EntradaArpValidationSchema);
			break;
		case 'COMPRA_EMERGENCIAL':
			handleValidationSchema(EntradaCompraEmergencialValidationSchema);
			break;
		case 'ESTOQUE_DACA':
			handleValidationSchema(EntradaDefesaCivilValidationSchema);
			break;
		default:
			break;
		}
	}

	render() {
		const {
			transacao,
			handleChange,
			setFieldValue,
			handleValidationSchema,
		} = this.props;

		return (
			<React.Fragment>
				<div className='row'>
					<div className='col-12'>
						<p><strong>Item:</strong> {transacao.daca.nome}</p>
					</div>
					<div className='col-md-12'>
						<div>
							<label>Tipo de entrada: <Required /></label>
						</div>
						<div className='form-group'>
							<div className='form-check form-check-inline'>
								<Input
									id='radio_1'
									name='tipoEstoque'
									type='radio'
									className='form-check-input'
									value='ARP'
									checked={transacao.destinoEstoque.tipoEstoque === 'ARP'}
									onChange={(e) => {
										if (transacao.destinoEstoque.numero && !transacao.destinoEstoque.numero.match(/\d{4}([/])\d{4}/g)) {
											setFieldValue(
												'destinoEstoque.numero',
												`${transacao.destinoEstoque.numero.substring(0, 4)}/${transacao.destinoEstoque.numero.substring(4, transacao.destinoEstoque.numero.length)}`,
											);
										}
										setFieldValue('destinoEstoque.tipoEstoque', e.target.value);
										handleValidationSchema(EntradaArpValidationSchema);
									}}
								/>
								<label
									htmlFor='radio_1'
									className='form-check-label pointer-text'
								>
									ARP
								</label>
							</div>

							<div className='form-check form-check-inline'>
								<Input
									id='radio_2'
									name='tipoEstoque'
									type='radio'
									className='form-check-input'
									value='COMPRA_EMERGENCIAL'
									checked={transacao.destinoEstoque.tipoEstoque === 'COMPRA_EMERGENCIAL'}
									onChange={(e) => {
										setFieldValue('destinoEstoque.tipoEstoque', e.target.value);
										handleValidationSchema(EntradaCompraEmergencialValidationSchema);
									}}
								/>
								<label
									htmlFor='radio_2'
									className='form-check-label pointer-text'
								>
									Compra emergencial
								</label>
							</div>

							<div className='form-check form-check-inline'>
								<Input
									id='radio_3'
									name='tipoEstoque'
									type='radio'
									className='form-check-input'
									value='ESTOQUE_DACA'
									checked={transacao.destinoEstoque.tipoEstoque === 'ESTOQUE_DACA'}
									onChange={(e) => {
										setFieldValue('destinoEstoque.tipoEstoque', e.target.value);
										handleValidationSchema(EntradaDefesaCivilValidationSchema);
									}}
								/>
								<label
									htmlFor='radio_3'
									className='form-check-label pointer-text'
								>
									Defesa Civil Nacional
								</label>
							</div>
						</div>
					</div>
					<ErrorMessage
						name='tipoEstoque'
						render={msg => (
							<span className='ml-3 text-danger'>
								{msg}
							</span>
						)}
					/>
				</div>

				{/* Renderiza o componente com os campos relativos a um ARP para edição */}
				{transacao.destinoEstoque.tipoEstoque === 'ARP' && (
					<EditarHistoricoARP
						transacao={transacao}
						handleChange={handleChange}
						setFieldValue={setFieldValue}
					/>
				)}

				{/* Renderiza o componente com os campos relativos a uma Compra emergêncial para edição */}
				{transacao.destinoEstoque.tipoEstoque === 'COMPRA_EMERGENCIAL' && (
					<EditarHistoricoCompraEmergencial transacao={transacao} handleChange={handleChange} />
				)}

				{/* Renderiza o componente com os campos relativos a Defesa civil para edição */}
				{transacao.destinoEstoque.tipoEstoque === 'ESTOQUE_DACA' && (
					<EditarHistoricoDefesaCivil transacao={transacao} handleChange={handleChange} />
				)}

				{/* Renderiza o compondente para edição de empresa, comum entre ARP e compra emergêncial */}
				{
					(transacao.destinoEstoque.tipoEstoque === 'ARP' || transacao.destinoEstoque.tipoEstoque === 'COMPRA_EMERGENCIAL')
					&& (
						<EditarEmpresa
							empresa={transacao.destinoEstoque.empresa}
							handleChange={handleChange}
							setFieldValue={setFieldValue}
						/>
					)
				}
			</React.Fragment>
		);
	}
}

export default EditarHistoricoDACAEntrada;
